var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoTo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01094 9.88195L8.85469 7.1007C8.92344 7.0507 8.92344 6.94914 8.85469 6.89914L5.01094 4.11789C4.92813 4.05852 4.81251 4.11789 4.81251 4.21945V4.95227C4.81251 5.11164 4.88907 5.2632 5.01876 5.35695L7.29063 6.99914L5.01876 8.64289C4.88907 8.73664 4.81251 8.88664 4.81251 9.04758V9.78039C4.81251 9.88195 4.92813 9.94133 5.01094 9.88195Z",
    fill: "#5A2FB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3127 0.749756H0.812744C0.536182 0.749756 0.312744 0.973193 0.312744 1.24976V12.7498C0.312744 13.0263 0.536182 13.2498 0.812744 13.2498H12.3127C12.5893 13.2498 12.8127 13.0263 12.8127 12.7498V1.24976C12.8127 0.973193 12.5893 0.749756 12.3127 0.749756ZM11.6877 12.1248H1.43774V1.87476H11.6877V12.1248Z",
    fill: "#5A2FB1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoTo);
export default __webpack_public_path__ + "static/media/goTo.54794c36.svg";
export { ForwardRef as ReactComponent };